package com.brdgwtr.designsystem.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.EvenOdd
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import com.brdgwtr.designsystem.Icons

public val Icons.ShowFilled: ImageVector
    get() {
        if (_showFilled != null) {
            return _showFilled!!
        }
        _showFilled = Builder(name = "ShowFilled", defaultWidth = 48.0.dp, defaultHeight = 48.0.dp,
                viewportWidth = 48.0f, viewportHeight = 48.0f).apply {
            path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(27.6366f, 24.5001f)
                curveTo(27.6366f, 26.4725f, 26.0086f, 28.0715f, 24.0003f, 28.0715f)
                curveTo(21.992f, 28.0715f, 20.3639f, 26.4725f, 20.3639f, 24.5001f)
                curveTo(20.3639f, 22.5276f, 21.992f, 20.9287f, 24.0003f, 20.9287f)
                curveTo(26.0086f, 20.9287f, 27.6366f, 22.5276f, 27.6366f, 24.5001f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = EvenOdd) {
                moveTo(24.0f, 12.0001f)
                curveTo(32.4583f, 12.0001f, 39.4583f, 16.5417f, 44.0f, 24.5834f)
                curveTo(39.75f, 32.3751f, 32.4583f, 37.0001f, 24.0f, 37.0001f)
                curveTo(16.25f, 37.0001f, 8.7917f, 32.6667f, 4.0f, 24.4584f)
                curveTo(8.4583f, 16.4584f, 15.9167f, 12.0001f, 24.0f, 12.0001f)
                close()
                moveTo(31.273f, 24.5001f)
                curveTo(31.273f, 28.445f, 28.0169f, 31.643f, 24.0003f, 31.643f)
                curveTo(19.9837f, 31.643f, 16.7275f, 28.445f, 16.7275f, 24.5001f)
                curveTo(16.7275f, 20.5552f, 19.9837f, 17.3572f, 24.0003f, 17.3572f)
                curveTo(28.0169f, 17.3572f, 31.273f, 20.5552f, 31.273f, 24.5001f)
                close()
            }
        }
        .build()
        return _showFilled!!
    }

private var _showFilled: ImageVector? = null
